export function sortFolders(a, b) {
  var nameA = a.GetFolderName().toLowerCase();
  var nameB = b.GetFolderName().toLowerCase();

  if (nameA == nameB) return 0;
  else if (nameA < nameB) return -1;

  return 1;
}
